import PropTypes from 'prop-types';
import React from 'react';
// import { browserHistory } from 'react-router';
import cx from 'classnames';
import { Image, FormGroup, InputGroup, FormControl, Dropdown, Button as SearchButton } from 'react-bootstrap';
import isEqual from 'is-equal';
import _ from "lodash";
import buildUrl from 'build-url-ts';
import styles from './userDetailView.module.scss';
import CommonStyles from '../../Styles.module.scss';
import UserListContainer from './UserListContainer';
import BackButton from 'src/legacy/components/BackButton';
import dateformat from 'dateformat';
import UserGroupListContainer from './UserGroupListContainer.jsx';
import { localizedStrings } from 'src/localization/index.jsx';
import userRoleService from "src/utils/userRoles.service";
import SwitchButton from 'src/components/switchButton';
import Toast from 'src/components/toast';
import { toast } from 'react-toastify';
import Text from 'src/components/text';

let InviteUserIcon = '/images/Paperflite.png';
class UserDetailView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      admin: false,
      createStream: false,
      canViewReports: false,
      query: "",
      location: this.props.location,
      activeUserRole: "",
      activeUserRoleId: "",
      isStarterLicence: _.get(this.props, "starterRole", false),
      starterRole: false
    }

    this._handleUserActivationClick = this._handleUserActivationClick.bind(this);
    this._handleSearch = this._handleSearch.bind(this);
    this._handleSearchQueryChange = this._handleSearchQueryChange.bind(this);
    this._handleUserRole = this._handleUserRole.bind(this);
    this.handleToggle = this.handleToggle.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedUserManagement = this.localizedSettings.account.user_management;
    this.localizedUser = this.localizedUserManagement.user_view;
  }

  _handleUserActivationClick() {
    let user = {
      "id": this.props.user.id,
      "admin": this.props.user.admin,
      "enabled": !this.props.user.enabled,
      "canCreateStream": this.props.user.createStream,
      "canViewReports": this.props.user.canViewReport,
    }

    this.props.updateUserActivation(user).then(() => {
      toast(
        <Toast.Sucess
          message={localizedStrings.formatString(this.localizedUser.toast.update, {status: this.props.user.enabled ? this.localizedCommons.activated : this.localizedCommons.deactivated})}
        />, {
          autoClose: 3000,
        })
    });
  }

  showField(field){
    if(field === 'createStream'){
      return 'create stream'
    }else if(field === 'canViewReports'){
      return 'view reports'
    }
    return field;
  }

  _handleSearch(event) {
    event.preventDefault();

    var queryParams = {};
    if (this.state.query) {
      queryParams['query'] = this.state.query;
    }

    var path = buildUrl(null, {
      path: this.props.location.pathname,
      queryParams: queryParams
    });

    this.props.navigate(path);
    this.props.fetchUserManagementList(0, this.state.query, 'users');
  }

  _handleSearchQueryChange(e) {
    this.setState({
      query: e.target.value
    })
  }

  handleToggle() {
    this.setState((prevState) => ({
      isStarterLicence: !prevState.isStarterLicence,
      starterRole: !prevState.starterRole
    }), () => {
      const normalUserRole = _.get(this.props, "userRoles").find(role => role.name === "Normal User");
      let user = {
        id: this.props.user.id,
        roles: _.get(this.state, "starterRole") ? [] : [{id: normalUserRole.id, name: normalUserRole.name }],
      };
      this.props.assignUserRole(user).then(() => {
        toast(
          <Toast.Sucess
            message={localizedStrings.formatString(this.localizedUser.toast.role, { activeUserRole: this.state.activeUserRole })}
          />, {
            autoClose: 3000,
          }
        );
      });
    });
  }

  _handleUserRole(userRole) {
    this.setState({
      activeUserRole: userRole.name,
      activeUserRoleId: userRole.id
    }, () => {
      let user = {
        id: this.props.user.id,
        roles: _.get(this.state,"isStarterLicence") ? [] : [{"id": this.state.activeUserRoleId, "name": this.state.activeUserRole}],
      }
      this.props.assignUserRole(user).then(() => {
        toast(
          <Toast.Sucess
          message={localizedStrings.formatString(this.localizedUser.toast.role, {activeUserRole: this.state.activeUserRole})}
          />, {
          autoClose: 3000,
        })
      });;
    })
  }

  componentDidMount() {
    this.props.hideSettingsSideMenu();
    this.setState({
      admin: this.props.user && this.props.user.admin,
      createStream: _.get(this.props.user, "canCreateStream", false),
      canViewReports: _.get(this.props.user, "canViewReport", false),
      activeUserRole: _.get(this.props.user, "role", ''),
      isStarterLicence: _.get(this.state, "isStarterLicence", "")
    })

    var query = this.props.location.query['query'] || '';
    if (query) {
      this.setState({
        query: query
      })
    }

    this.props.fetchUserGroupsForUser(0, this.props.user.id);
    this.props.fetchUserRolesForAccount();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.user !== nextProps.user && nextProps.user) {
      this.setState({
        admin: nextProps.user && nextProps.user.admin,
        createStream: _.get(nextProps.user, "createStream", false),
        canViewReports: _.get(nextProps.user, "canViewReports", false) || (nextProps.user && nextProps.user.admin),
        activeUserRole: _.get(nextProps.user, "userRoles[0].name", '')
      })
    }

    var query = nextProps.location.query['query'] || '';
    if (query) {
      this.setState({
        query: query
      })
    }

    if (!isEqual(this.props.location.search, nextProps.location.search)) {
      this.setState({
        location: nextProps.location
      });
    }
  }

  componentWillUnmount() {
    this.props.invalidateUser();
    this.props.showSettingsSideMenu();
  }

  render() {

    return (
      <div className={styles.content}>
        <div className={styles.listView}>
          <BackButton
            className={CommonStyles.back}
            title={this.localizedCommonActions.back}
            onClick={() => {
              this.props.invalidateAccountUsers();
              this.props.navigate(`/settings/user-management`);
              this.props.showSettingsSideMenu();
            }}>
          </BackButton>

          <h1 className={styles.heading}>{this.localizedUserManagement.title}</h1>

          <form className={styles.search} onSubmit={this._handleSearch}>
            <FormGroup className={styles.formGroup}>
              <InputGroup className={styles.inputGroup}>
                <div className={styles.addon}>
                  <span className={cx(styles.searchIcon, "paperflite-search")}></span>
                </div>
                <FormControl type="text"
                  placeholder={this.localizedUser.search_users_placeholder}
                  value={this.state.query}
                  onChange={this._handleSearchQueryChange} />
                <div>
                  <SearchButton className={styles.button} type="submit">{this.localizedCommonActions.search}</SearchButton>
                </div>
              </InputGroup>
            </FormGroup>
          </form>

          <UserListContainer store={this.context.store}
            query={this.state.query}
            location={this.state.location}
            params={this.props.params} />
        </div>
        {this.renderUserDetail()}
      </div>
    );
  }

  renderUserDetail() {
    var roles = this.props.userRoles.map((userRole, index) => {
      return (
        <Dropdown.Item className={styles.userRoleItem} key={index} onClick={this._handleUserRole.bind(this, userRole)}>{userRole.name}</Dropdown.Item>
      )
    });
    var popoverMenu = (
      <Dropdown.Menu>
        {this.props.showManageRoles && (
          <Dropdown.Item
            className={styles.createNewRole}
            onClick={() => this.props.navigate("/settings/user-roles/new")}
          >
            <i className="paperflite-add" />
            <p>{this.localizedUser.actions.create_new_role}</p>{" "}
          </Dropdown.Item>
        )}
        {roles}
      </Dropdown.Menu>
    );
    
    if (_.isEmpty(this.props.user)) {
      return null;
    }

    return (
      <div className={styles.userDetailsView}>
        <div className={styles.detailsContainer}>
          <div>
            <Image
              className={styles.icon}
              src={
                (_.get(this.props, 'user.entityType') === "user")
                ? _.get(this.props, 'user.icon.full', InviteUserIcon)
                  : InviteUserIcon
              }
              circle
            />
          </div>
          <div className={styles.username}>
            <Text text={` ${_.get(this.props, 'user.firstName', '')} ${_.get(this.props, 'user.lastName', '')} `.trim()} lines={2} />
          </div>
          <div className={styles.email}>{this.props.user.email}</div>
          <div className={styles.createdDate}>
            {this.localizedUser.user_since}{" "}
            {dateformat(this.props.user.createdDate, "dd mmm yyyy")}
          </div>

          <div className={styles.buttonTray}>
          <button className={styles.activationButton} disabled={this.props.updating} onClick={() => { this._handleUserActivationClick() }}>
              {this.props.user.enabled && !this.props.updating && this.localizedUser.actions.deactivate_account}
              {!this.props.user.enabled && !this.props.updating && this.localizedUser.actions.activate_account}
              {this.props.user.enabled && this.props.updating && `${this.localizedUser.actions.deactivating_account}...`}
              {!this.props.user.enabled && this.props.updating && `${this.localizedUser.actions.activating_account}...`}
            </button>
          </div>

          <div className={styles.access}>
            <div className={cx(styles.label,styles.settingsName,
            { [styles.settingsNameDisabled]: this.state.isStarterLicence })}
            >
              {this.localizedUser.select_role}:
            </div>
            <div className={styles.select}>
              {!_.get(this.props, "starterRole") && (
                <Dropdown id="dropdown-user-role" rootCloseEvent="click">
                 <Dropdown.Toggle className={styles.toggleWrapper}>
                  <Text lines={1} className={cx( styles.activeUserRole,{ [styles.loadingText]: this.props.updating})}  text={`${_.get(this.props.user, "userRoles[0].name", this.localizedUser.user_role)}`} />
                 </Dropdown.Toggle>
                  {popoverMenu}
                </Dropdown>
              )}
            </div>
          </div>
          {userRoleService.canAccessStarterRole(_.get(this.props, "account")) &&  (
            <div className={styles.switchButtonContainer}>
              <SwitchButton
                id="switchButton"
                className={styles.switchButton}
                handleCheck={this.handleToggle}
                checked={_.get(this.state, "isStarterLicence") || _.get(this.props, "starterRole")}
              />
              <span className={styles.switchText}>{this.localizedUser.starter_role}
              </span>
            </div>
          )}
          <UserGroupListContainer user={this.props.user} />
        </div>
      </div>
    );
  }

}

export default UserDetailView;    